<template>
  <div>
    <google-map
      ref="gm"
      :sharer="sharerId"
      :show-lengend="showLegend"
      map-style="elevation"
      :show-sites="true"
      :legend="legend" />
  </div>
</template>


<script>

import GoogleMapMixins from '@/mixins/GoogleMapMixins'
import NumberMixins from '@/mixins/NumberMixins'

import GoogleMap from '@/components/maps/GoogleMap'

export default {

  mixins: [GoogleMapMixins, NumberMixins],

  components: {
    GoogleMap
  },



  props: {

    sharer: {
      type: Number,
      default: null
    },

    showLegend: {
      type: Boolean,
      default: true
    },

    showSites: {
      type: Boolean,
      default: true
    }

  },



  watch: {
    sharer: function (val) {
      this.sharerId = val === 0 ? null : Number(val)
      this.$refs.gm.sharerChange(this.sharerId)
    }

  },



  methods: {

    sharerStatus (m) {
//      console.log('m', m)
      return m.content.siteName +
      (m.content.sharers ? ' | Sharers: ' + m.content.sharers + ' | ' : '') +
      (m.content.structureType
        ? (m.content.structureType + (m.content.structureHeight ? ' (' + m.content.structureHeight + 'm)' : '') + ' | ')
        : '')
    },

    mapSharerIcon (sharers) {

      sharers = Number(sharers)

      if (sharers === null) {
        return this.defaultIcon()
      }

      if (sharers <= 0) {
        return this.redIcon()
      }

      if (sharers >= 5) {
        return this.yellowIcon()
      }

      if (sharers === 4) {
        return this.pinkIcon()
      }

      if (sharers === 3) {
        return this.blueIcon()
      }

      if (sharers <= 2) {
        return this.greenIcon()
      }
    }


  },



  data () {

    return {
      sharerId: this.sharer,
      legend: {
        title: null,
        sharerId: this.sharer,
        statusFormatter: this.sharerStatus,
        mapIcon: this.mapSharerIcon,
        prop: 'sharers'
      }
    }

  }

}

</script>
